import React from 'react';
import propTypes from './propTypes';

const Weighing = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M22 16H2V18H4V20H2V22H22V20H20V18H22V16ZM18 18H6V20H18V18Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M19 4.99991H16V1.99991H4C2.9 1.99991 2 2.89991 2 3.99991V12.9999H4C4 14.6599 5.34 15.9999 7 15.9999C8.66 15.9999 10 14.6599 10 12.9999H14C14 14.6599 15.34 15.9999 17 15.9999C18.66 15.9999 20 14.6599 20 12.9999H22V8.99991L19 4.99991ZM16 6.746H18.1133L20.2838 9.6171V10.9999H19.2361C18.6868 10.3862 17.8885 9.99991 17 9.99991C16.6494 9.99991 16.3128 10.0601 16 10.1706V6.746ZM6 12.9999C6 13.5499 6.45 13.9999 7 13.9999C7.55 13.9999 8 13.5499 8 12.9999C8 12.4499 7.55 11.9999 7 11.9999C6.45 11.9999 6 12.4499 6 12.9999ZM9.22 10.9999C8.67 10.3899 7.89 9.99991 7 9.99991C6.11 9.99991 5.33 10.3899 4.78 10.9999H4V3.99991H14V10.9999H9.22ZM16 12.9999C16 13.5499 16.45 13.9999 17 13.9999C17.55 13.9999 18 13.5499 18 12.9999C18 12.4499 17.55 11.9999 17 11.9999C16.45 11.9999 16 12.4499 16 12.9999Z" fill="currentColor" />
  </svg>
);

Weighing.propTypes = propTypes;

export default Weighing;
